import LegalPageLayout from "@/components/LegalPageLayout";

const ShippingPolicyPage = () => (
  <LegalPageLayout title="Service Delivery & Shipping Policy" lastUpdated="April 2026" testId="shipping-policy-page">
    <p>
      This Service Delivery Policy explains how and when you receive the products you purchase on <strong>tots360</strong>.
      Because tots360 sells only digital, non-physical products, this Policy covers <strong>electronic delivery timelines</strong>
      rather than physical shipping. Razorpay and Stripe require this page to confirm the nature of our fulfilment.
    </p>

    <h2>1. What you are buying</h2>
    <p>
      tots360 offers digital <strong>report credits</strong>. Each credit unlocks the generation of one AI-assisted PDF health
      report (BoneAH or NIN-NutriGuide). There are <strong>no physical goods</strong> shipped at any stage.
    </p>

    <h2>2. Delivery of credits</h2>
    <ul>
      <li>Credits are delivered <strong>instantly</strong> (typically within a few seconds) to your tots360 account after a successful payment has been verified by the payment gateway.</li>
      <li>In the rare event of a gateway delay, credits are automatically reconciled within <strong>1–2 hours</strong> via background verification.</li>
      <li>Your updated credit balance is visible on your dashboard immediately after reconciliation.</li>
    </ul>

    <h2>3. Delivery of the PDF report</h2>
    <ul>
      <li>Reports are generated on-demand when you click <em>&ldquo;Download PDF Report&rdquo;</em> after completing an analysis.</li>
      <li>Typical generation time is <strong>5–30 seconds</strong>, depending on the complexity of the analysis and server load.</li>
      <li>The PDF is delivered directly to your browser as a file download. A copy is also saved to your <em>Reports</em> history for later re-download (free of charge).</li>
    </ul>

    <h2>4. Failure to deliver</h2>
    <p>
      If credits are not delivered to your account, or a PDF fails to download despite a credit being consumed, please contact us
      at <a href="mailto:info@tots360.in">info@tots360.in</a> within <strong>7 days</strong> of the transaction.
      Upon verification we will either restore the credit or issue a refund in accordance with our
      <a href="/refund-policy"> Refund &amp; Cancellation Policy</a>.
    </p>

    <h2>5. Physical shipping</h2>
    <p>
      <strong>We do not ship physical goods.</strong> If you receive a communication claiming to ship anything physical on behalf of
      tots360, it is fraudulent — please report it to <a href="mailto:info@tots360.in">info@tots360.in</a>.
    </p>

    <h2>6. Service availability</h2>
    <p>
      The Service is accessible 24×7 over the internet. We aim for a minimum 99% monthly uptime excluding scheduled maintenance
      windows. Scheduled maintenance is typically performed between 01:00 and 05:00 IST and is announced in advance whenever
      possible.
    </p>

    <h2>7. Changes to this Policy</h2>
    <p>
      We may update this Policy to reflect changes in our delivery or infrastructure. The &ldquo;Last updated&rdquo; date at the
      top of this page will always reflect the most recent revision.
    </p>

    <h2>8. Contact</h2>
    <p>
      For any delivery-related query, write to us at <a href="mailto:info@tots360.in">info@tots360.in</a> or call
      +91 89857 09090 (Mon–Sat, 10:00–18:00 IST).
    </p>
  </LegalPageLayout>
);

export default ShippingPolicyPage;
